import React, { useState } from "react";
import {
  Row,
  Col,
  Spin,
  message,
} from "antd";
import IntlMessages from "../../../util/IntlMessages";
import ds from "../../../Services/DataServices";
import { useHistory } from "react-router-dom";
import { useDispatch, useStore, useSelector } from "react-redux";
import { BEHAVIOUR_TYPE } from "../../../Services/DataServices";
import Auxiliary from "../../../util/Auxiliary";
import TrackCard from "../../../components/SellScreen/TrackCard";
import { getDecryptID } from "../../../appRedux/actions";
import { SALE_TRACKING } from "../../../constants/StoreSetting";
import NotAllowedComponent from "../../../components/NotAllowedComponent";

const Serving = (props) => {
  const { isUpdate, interval, outletID, outletName } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const [isLoading, setIsLoading] = React.useState(true);
  const [pinchData, setPinchData] = React.useState(false);
  const [getTableData, setTableData] = React.useState([]);
  const [getIsAllowRead, setIsAllowRead] = useState(true);
  const [getAccessLoading, setAccessLoading] = useState(false);

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (outletID) {
        getSalesLogs({ OutletID: outletID });
      } else message.info('Please select your outlet');
    }
    return () => mounted = false;
  }, [interval]);

  React.useEffect(() => {
    let mounted = true;
    if (mounted) {
      let data = getTableData;
      //excluding those who have all served or cancel...!
      const listIDs = []; // all those who have status other than served/cancel (not those who have all served/canel)
      const tracks = [];
      data.map(a => {
        a.saleTrack.map((ee, i) => {
          if (ee.orderStatus) {
            let isOtherExist = false;
            if (getDecryptID(ee.orderStatus) != SALE_TRACKING.filter(b => b.NAME == "SERVED")[0].ID &&
              getDecryptID(ee.orderStatus) != SALE_TRACKING.filter(b => b.NAME == "CANCEL")[0].ID) {
              isOtherExist = true;
            }
            if (isOtherExist) {
              listIDs.push(a.salesOrderID ? a.salesOrderID : "");
              return;
            }
          }
        });
      });
      data.map(zx => {
        if (zx.salesOrderID) {
          const isExist = listIDs.filter(cc => getDecryptID(cc) == getDecryptID(zx.salesOrderID));
          if (isExist && isExist.length > 0) {
            tracks.push(zx);
          }
        }
      });
      data = tracks;
      setTableData(data);
    }
    return () => mounted = false;
  }, [pinchData]);

  async function getSalesLogs(body) {
    setIsLoading(true);
    const resp = ds.getSaleLogsService(body, BEHAVIOUR_TYPE.GET);
    await resp
      .then((res) => {
        setIsLoading(false);
        if (res && res.tracks && res.tracks.length > 0) {
          //excluding those who have all served or cancel...!
          const listIDs = []; // all those who have status other than served/cancel (not those who have all served/canel)
          const tracks = [];
          res.tracks.map(a => {
            a.saleTrack.map((ee, i) => {
              if (ee.orderStatus) {
                let isOtherExist = false;
                if (getDecryptID(ee.orderStatus) != SALE_TRACKING.filter(b => b.NAME == "SERVED")[0].ID &&
                  getDecryptID(ee.orderStatus) != SALE_TRACKING.filter(b => b.NAME == "CANCEL")[0].ID) {
                  isOtherExist = true;
                }
                if (isOtherExist) {
                  listIDs.push(a.salesOrderID ? a.salesOrderID : "");
                  return;
                }
              }
            });
          });
          res.tracks.map(zx => {
            if (zx.salesOrderID) {
              const isExist = listIDs.filter(cc => getDecryptID(cc) == getDecryptID(zx.salesOrderID));
              if (isExist && isExist.length > 0) {
                tracks.push(zx);
              }
            }
          });
          res.tracks = tracks;
          setTableData(res.tracks);
        } else {
          setTableData([]);
        }
      })
      .catch((e) => {
        setTableData([]);
        setIsLoading(false);
      });
  }

  function changePinch() {
    // serveDone();
    setPinchData(!pinchData);
  }

  return getIsAllowRead ? (
    <Spin
      tip={<IntlMessages id="sell.cashlisting.cashloading" />}
      spinning={isLoading}
      size="large"
      style={{ marginTop: 150 }}
    >
      <Auxiliary>
        {/* {outletName && (
          <h2>
            {`Outlet: ${outletName}`}
          </h2>
        )} */}
        <Row>
          {outletID ?
            <>
              {getTableData && getTableData.length > 0 &&
                getTableData.map((s, o) => {
                  return (
                    <Col key={o} xl={8} lg={12} md={24} sm={24} xs={24} className="sale-card-col">
                      <TrackCard data={s} isPreparing={false} pinch={changePinch} isUpdate={isUpdate} />
                    </Col>
                  );
                })}
            </>
            :
            <>
              <Col>
                <h1 style={{ marginTop: 38, marginLeft: 38 }}>
                  Please Select your Outlet
                </h1>
              </Col>
            </>
          }
        </Row>
      </Auxiliary>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  );
};

export default Serving;
